import { IconPause } from '@/app/components/icons/audio-video/icon-pause';
import { IconPlayArrow } from '@/app/components/icons/audio-video/icon-play-arrow';
import type { SpartanMediaPlaybackIconProps } from '@/app/lcv/components/sections/spartan/products/shared/media-playback-icon/types';
import { cn } from '@/app/utils/cn';

const ICON_TRANSITION_CLASS_NAME =
  'absolute inset-0 flex items-center justify-center transition-opacity duration-150 ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none';

export const SpartanMediaPlaybackIcon = ({
  isPlaying,
  isVisible = true,
  className,
}: SpartanMediaPlaybackIconProps) => {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'pointer-events-none relative block size-full [&_svg]:size-full [&_svg]:fill-current',
        className
      )}
    >
      <span
        className={cn(
          ICON_TRANSITION_CLASS_NAME,
          isPlaying && isVisible ? 'opacity-100' : 'opacity-0'
        )}
      >
        <IconPause />
      </span>
      <span
        className={cn(
          ICON_TRANSITION_CLASS_NAME,
          !isPlaying && isVisible ? 'opacity-100' : 'opacity-0'
        )}
      >
        <IconPlayArrow />
      </span>
    </span>
  );
};
